module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ethLz"))).then(() => parcelRequire('hEqeo'));